import { useEffect } from 'react';
import { GlobalActions } from '../../model/global-actions';
import appRoutes from '../../routing/app-routes';
import { getConfig, LoginState } from '../../store';
import { useAppDispatch, useAppSelector } from '../redux';
import { useAppNavigation } from '../../utils/navigation.utils';

export const useConfigLogic = (actions: GlobalActions): void => {
  const dispatch = useAppDispatch();
  const { pathname } = useAppNavigation();
  const { navigate } = actions;

  const { config }: LoginState = useAppSelector(
    (state) => state.features.login
  );

  useEffect(() => {
    if (config === undefined) {
      dispatch(getConfig());
    }
  }, [config, dispatch]);

  useEffect(() => {
    if (config?.maintenance === true) {
      navigate(appRoutes.Maintenance, { replace: true });
    } else if (
      config?.maintenance === false &&
      pathname === '/' + appRoutes.Maintenance
    ) {
      navigate(appRoutes.Login, { replace: true });
    }
  }, [config?.maintenance, navigate, pathname]);
};
